import classNames from 'classnames';
import styles from './index.module.scss';

function EmptyMessage({ className, message = 'Nothing to show here' }) {
  return (
    <section className={classNames(styles.container, className)}>
      <div className={styles.imageContainer}>
        <img className={styles.image} src="/images/warning-state.png" />
      </div>
      <p className={styles.message}>{message}</p>
    </section>
  );
}

export default EmptyMessage;
